import { render, staticRenderFns } from "./RsaPazienteAttivitaObiettiviObiettiviComponent.vue?vue&type=template&id=19698790&scoped=true"
import script from "./RsaPazienteAttivitaObiettiviObiettiviComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteAttivitaObiettiviObiettiviComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19698790",
  null
  
)

export default component.exports